import _ from "lodash";

export const AMENITY_LIST_REQUEST = 'AMENITY_LIST_REQUEST';
export const AMENITY_LIST_SUCCESS = 'AMENITY_LIST_SUCCESS';
var initialState = {
    byId: [],
    allIds: [],
    loading: false
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.amenity) {
        state = {
            ...state,
            byId: _.merge(state.byId, action.payload.entities.amenity)
        }
    }
    switch (action.type) {
        case AMENITY_LIST_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case AMENITY_LIST_SUCCESS:
            return {
                ...state,
                allIds: action.payload.result,
                loading: false
            }
        default:
            return state;
    }
};